<template>
    <v-app v-bind:class="{pdf: isPdf() }">
        <v-toolbar app>
            <img class="me" v-on:click="switchLang()" src="@/assets/me.png"/>
            <v-toolbar-title class="headline">
                <div class="flex">
                    <!--                    <div style="width:220px;">-->
                    <!--                        <div><b>{{root.name}}</b></div>-->
                    <!--                        <div style="color: gray; font-size: 18px"><i>{{root.age}}</i></div>-->
                    <!--                    </div>-->
                    <div>
                        <div><b>{{root.name}}</b></div>
                        <span><i>{{root.title}}</i></span>
                    </div>
                </div>
                <div class="downloadBtn">
                    <a v-bind:href="exportUrl"
                       download>
                        <i class="material-icons icon-image" v-bind:title="root.download">cloud_download</i>
                    </a>
                </div>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-content>
            <v-layout row>
                <v-flex xs-4 class="col-left-container">
                    <v-card class="col-left">
                        <div class="separator">
                            {{root.aboutMe}}
                        </div>
                        <div class="aboutMe">
                            <div v-html="root.aboutMe1"></div>
                        </div>
                        <div class="separator" style="margin-bottom: 0;">
                            {{root.technicalSkills}}
                        </div>
                        <div v-for="(link ,i) in skills" :key="i + 1000" class="mySkills">
                            <v-layout>
                                <v-flex align-center style="max-width: 90px;height:25px; display: flex;">
                                    <LinkComponent v-bind:theKey="link.key"/>
                                </v-flex>
                                <v-flex style="height:25px; margin-right: 0px;">
                                    <v-progress-linear
                                            color="secondary"
                                            height="5"
                                            :value="link.note.mark"
                                    ></v-progress-linear>
                                    <div class="xp">{{link.note.xp}}</div>
                                </v-flex>
                            </v-layout>
                        </div>
                        <div class="separator" style="margin: 0;">
                            {{root.persoLabel}}
                        </div>
                        <div v-for="(item ,i) in personnalStuff" :key="i + 3000" class="nopadding" :id="'personnal_'+i">
                            <div class="personnalTitle">{{item.title}}</div>
                            <div class="personnalDesc" v-html="item.desc"></div>
                            <span class="url" v-if="item.url">{{item.url}}</span>
                            <div v-for="(line ,j) in item.lines" :key="j + 4000" :class="'personal-block index_' + i + '_' + j  + ((j%2===0) ? ' alternate' : '')">
                                <div class="personnal">
                                    <div style="display: inline-block"><b>
                                        {{line.link ? line.link.label:''}}</b></div>
                                    <i style="color:grey">&nbsp; {{line.date ? "-" : " "}} {{line.date}}</i>
                                    <div class="skills">
                                        <span v-for="(skill, j) in formatKeySkills(line.skills)" v-bind:key="j + 4000">
                                            <LinkComponent v-bind:theKey="skill" :displayName="false"/>
                                        </span>
                                    </div>
                                </div>
                                <div class="url" v-if="line.link">
                                    <a v-bind:href="line.link.url" target="_blank">{{line.link.url}}</a>
                                </div>
                                <span style="color:#989898;">{{line.label}}</span>

                                <!--{{line.link}}-->
                            </div>
                        </div>


                        <div class="separator misc">
                            {{root.miscLabel}}
                        </div>
                        <div v-for="(row ,i) in miscs" :key="i">
                            <div style="width: 70px;display: inline-block"><b>{{row.label}}</b></div>
                            {{row.content}}
                        </div>
                        <div class="separator">
                            {{root.trainingLabel}}
                        </div>
                        <div v-for="(row ,i) in trainings" :key=" i + 2000">
                            <div style="width: 70px;display: inline-block"><b>{{row.date}}</b></div>
                            {{row.title}}
                            <div><i>{{row.content}}</i></div>
                        </div>

                        <div class="separator">
                            {{root.contactLabel}}
                        </div>
                        <div>

                        </div>
                        <div v-for="(row ,i) in root.contacts" :key=" i + 4000">
                            <a v-bind:href="row" target="_blank">{{row}}</a>
                        </div>
                    </v-card>
                </v-flex>
                <v-flex xs-8>
                    <TimelineComponent/>
                </v-flex>
            </v-layout>

        </v-content>
    </v-app>
</template>
<style lang="scss">

    /*MatIcons*/
    .icon-image {
        background-color: #c1c1c1;
        border-radius: 4px;
        padding: 2px;
        display: inline-block;
        font-size: 20px;
        width: 20px;
        overflow: hidden;
    }


    html {
        min-height: 2090px;

        a {
            color: darkblue;
        }
    }

    body {
        /*opacity: 0.2;*/
    }

    #app {
        .downloadBtn {
            cursor: pointer;

            &:hover {
                i {
                    background-color: #a2a2a2;
                }
            }

            a {
                color: black;
            }

            i {
                position: absolute;
                top: 21px;
                font-size: 30px;
                right: 20px;
                width: 40px;
            }
        }

        &:not(.pdf) {
            margin: auto;
        }

        &.pdf {
            nav {
                position: inherit;
            }

            main.v-content {
                padding: 0 !important;
            }

            .downloadBtn {
                display: none;
            }

          .personal-block.index_0_1 {
            margin-top: 100px;
            .personnal {

            }
          }
          .employer_eurofins,
          .employer_livingpackets {
            margin-top: 100px;
            .v-timeline-item__body{
              margin-top: 20px;
            }
          }

          .separator.misc {
            margin-top: 300px;
          }

        }

        width: 824px;
        height: 1045px;
        background-color: white;
        //border: 1px solid red;

        .v-toolbar {
            .v-toolbar__content {
                text-align: center;

            }

            .v-toolbar__title {
                width: 100%;
            }

            .flex {
                display: flex;
                width: 100%;
                justify-content: space-around;
                align-items: center;
                /*flex-direction: row;*/
            }

            .v-toolbar__content {
                height: 80px !important;
            }
        }


        main.v-content {
            padding: 80px 0 0 0 !important;
        }


        .v-progress-linear {
            margin: 10px 0px;
        }

        .mySkills:nth-child(2n+1) {
            background-color: #F1F1F1;
        }

        .mySkills {
            padding-right: 0;
            margin: 5px 5px;
            .sprite {
                margin: 0 5px;
                position: relative;
                top: 2px;
            }
            .flex {
                display: flex;
            }
            .xp {
                font-weight: bold;
                color: grey;
                width: 75px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }

    .me {
        height: 70px;
    }

    .col-left-container {
        height: 100%;
    }

    .col-left {
        //$base-color: #9D81D1;
        $base-background-color: #afc1c8;//#B7B7FF;//#A6DEEE;//#C6C6FF;
        $base-color: black;

        margin-left: 5px;
        padding-bottom: 15px;
        height: 100%;

        & > div {
            padding: 0 10px;
        }

        width: 300px;
        font-size: 12px;

        .separator {
            font-weight: 500;
            text-align: center;
            background-color: $base-background-color; // #4caf50;
            padding: 5px;
            margin: 10px 0;
            color: $base-color;
            font-size: 15px;
        }

        .aboutMe {
            font-size: 12px;
            font-style: italic;
        }


        .url {
            /*font-size: 9px;*/
            /*margin-left: 10px;*/
            color: darkblue;
            text-decoration: underline;
        }

        .personnalTitle {
            font-size: 13px;

            //font-weight: bold;
            height: 20px;
            display: flex;
            align-items: center;
            align-content: center;
            justify-content: center;
            //font-style: italic;
            color: $base-color;
            background-color: lightgray;//$base-background-color;
            /*border-bottom: 1px solid $base-color;*/
            margin: 12px 10%;
            border-radius: 4px;
            padding: 15px 0px;
        }

        .personnalDesc{
          //text-decoration: underline;
          //font-style: italic;
          padding: 0 10px 0px 10px;
          margin-bottom: 10px;
        }

        .nopadding {
            padding: 0;
        }

        .personnal {
            display: flex;
            align-items: center;
            .skills {
                border-radius: 3px;
                /*height: 20px;*/
                display: flex;
                /*justify-content: flex-end;*/
                margin-left: auto;

                .sprite {
                    position: relative;
                    top: 2px;
                    margin-left: 5px;
                }
            }
        }

        .personal-block {
            &.alternate {
                background-color: #F1F1F1;;
            }

            padding: 14px 10px;
        }

    }

    .mmission {
      margin: 10px 0;

      .mmission_title {
        margin-bottom: 5px;
      }
    }
</style>

<script>
    let isPdf = false;
    import TimelineComponent from './components/TimelineComponent';
    import LinkComponent from './components/LinkComponent';
    import DataService from './services/dataService';
    import Vue from 'vue';

    Vue.prototype.$dataService = new DataService();
    if (window.location.href.includes('en')) {
        Vue.prototype.$dataService.changeLang('en');
    }
    export default {
        name: 'App',
        components: {
            // MissionComponent,
            LinkComponent,
            TimelineComponent
        },
        created: function () {
            if (window.location.href.includes('pdf')) {
                isPdf = true;
            }
        },
        data: function () {
            const self = this;
            const skills = ['js', 'typescript', 'angular2',  'nodejs', 'vuejs', 'react', 'git', 'css3', 'html5','linux', 'windows']
                .map(key => {
                    return {
                        key,
                        note: self.$dataService.getSkill(key),
                    };
                });

            let exportUrl = 'https://us-central1-shareyourbooks-254022.cloudfunctions.net/urltopdf/urltopdf/https:@s@@s@alban44.github.io@q@pdf/CV_Alban_Alnot';
            if(window.location.href.includes('localhost')){
                exportUrl = 'http://localhost:4000/urlToPdf/http:@s@@s@localhost:8080@q@pdf-fr/cv-local';
            }

            return {
                skills,
                miscs: this.$dataService.getMiscs(),
                trainings: this.$dataService.getTrainings(),
                personnalStuff: this.$dataService.getPersonalStuffs(),
                root: this.$dataService.getAll(),
                componentKey: 0,
                exportUrl
            }
        },
        methods: {
            switchLang: function () {
                this.$dataService.changeLang();
            },
            isPdf: () => {
                return isPdf;
            },
            formatKeySkills: (skills) => {
                return skills
                    .filter(x => ['js', 'nodejs', 'react', 'vuejs', 'git'/*, 'html5', 'css3'*/].includes(x));
            }
        }
    }
</script>
